import { Influencer } from '@cuepid/core';

export class NegativeInfluencerHandle {
  isNegativeUser(influencer?: Influencer): boolean {
    return !!influencer?.settings?.negative;
  }
}
